export const getLiteSegment = (client, req) => client.rpcNoAuth('service-content', '1/2018-07-23/get_lite_segment', req);
export const getFullSegment = (client, req) => client.rpcNoAuth('service-content', '1/2018-07-23/get_full_segment', req);
export const getPages = (client) => client.rpcNoAuth('service-content', '1/2018-07-23/get_pages', void 0);
export const getDocumentBase = (client) => client.rpcNoAuth('service-content', '1/2018-07-23/get_document_base', void 0);
